import React from 'react';

const AsyncClientPage = React.lazy(() => import('./ClientContainer'));

export const ClientPage = () => {
  return <AsyncClientPage />;
};
